export function path (path, param = null) {
  return `${path}${param ? `/${param}` : ''}`
}


// WEBPACK FOOTER //
// ./src/repositories/helpers.js